<template>
  <div>
    <h2>Testimonials</h2>
    <p class="quote right">
      "Lenore's piano lessons have been a meaningful part of our family life for
      many years. She responds to and engages each of us in a way that nurtures
      our enjoyment of music and our musical progress."
    </p>
    <p class="attribution right">
      - Catherine M, student and mother of two
    </p>
    <br/>
    <p class="quote">
      "Lenore has inspired my son to really want to play piano.
      Imagine how amazing it is for a parent to never have to tell their child to
      practice!"
    </p>
    <p class="attribution">
      - Nadra M, mother of one
    </p>
    <br/>
    <p class="quote right">
      "My three children have been enjoying their piano lessons with Lenore for years.
      Her lessons are a highlight of their week, and I
      highly recommend Lenore for students of all ages."
    </p>
    <p class="attribution right">
      - Lora E, mother of three
    </p>
    <br/>
  </div>
</template>

<script>
export default {
  name: "Testimonials"
}
</script>

<style scoped>

.quote {
  font-style: italic;
}

.attribution {
  font-size: 1.5em;
}

</style>